// i18n area 'system' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.bg-BG.meta.json.
import type { enUS } from './system'

export const bgBG: typeof enUS = {
    diagnostics: {
    title: 'Диагностика',
    subtitle: 'Какво не е наред, най-лошото първо — същата леща като tvirt diagnose',
    reload: 'Презареди',
    loadError: 'Диагнозата не можа да бъде прочетена',
    exportBundle: 'Експортирай пакета',
    exportError: 'Пакетът не можа да бъде създаден',
    noProblem: 'Няма проблем в проверените области',
    nothingInspected: 'НИЩО не беше проверено — това не е свидетелство за добро здраве',
    inspected: 'Проверени',
    notInspected: 'НЕПРОВЕРЕНИ',
    localHint: 'Локалните области на възела (systemd единици, журнал) се четат само от CLI: tvirt diagnose --area local — пътят, когато API не отговаря.',
    thresholds: 'неуспешни задачи в рамките на {hours} ч, heartbeat закъснял над {seconds} с',
    severity: {
      critical: 'Критично',
      warning: 'Предупреждение',
      unknown: 'Неизвестно'
    }
  },
  explorer: {
        title: 'Разглеждане на ресурсите',
        root: 'Корен',
        empty: 'Няма ресурси в този скоуп',
        previewHint: 'Изберете обект, за да видите неговия преглед',
        open: 'Отвори',

        // Дълбоката връзка ?scope= на CRUD списъците (рунд #109), от разглеждането (#143).
        openScoped: 'Отвори списъка в този скоуп',
        kinds: {
            vm: 'ВМ',
            vmTemplate: 'ВМ шаблон',
            ct: 'CT',
            ctTemplate: 'CT шаблон',
            app: 'Приложение',
            overlayNetwork: 'Оверлейна мрежа',
            networkService: 'Мрежова услуга',
            fabric: 'Фабрика',
            subnet: 'Подмрежа',
            storage: 'Хранилищен пул',
            disk: 'Диск',
            catalogFile: 'Файл от каталога',
            ociRegistry: 'OCI регистър',
            ociImage: 'OCI образ',
            cephCluster: 'Ceph клъстер',
            backupDestination: 'Дестинация за бекъп',
            user: 'Потребител',
            group: 'Група',
            role: 'Роля',
            credential: 'Идентификационни данни',
            tag: 'Таг',
            proximityRule: 'Правило за близост'
        }
    },
    tags: {
        title: 'Тагове',
        empty: 'Няма тагове',
        add: 'Добави таг',
        remove: 'Премахни',
        name: 'Таг',
        value: 'Стойност',
        save: 'Запази',
        saveError: 'Неуспешно запазване на таговете',
        loadError: 'Неуспешно зареждане на речника с тагове',
        noVocabulary: 'Няма наличен таг за този тип ресурс',

        // Вече зададен единичен таг отговаря с 409: замяната е винаги изрична —
        // никога мълчалива подмяна (проектно решение, ратифицирано 2026-07-27).
        overwrite: 'Замени текущата стойност',

        // Система > Тагове, повърхността на речника.
        createTitle: 'Създаване на таг',
        editTitle: 'Редактиране на таг',
        nameHint: 'Букви, цифри, точки, тирета и долни черти — без ":" и без "/"; префиксът tvirt- принадлежи на платформата',
        cardinality: 'Кардиналност',
        cardinalitySingle: 'Една стойност',
        cardinalityMultiple: 'Няколко стойности',
        cardinalityHint: 'При една стойност повторното задаване на тага иска да я замените',
        autoCreate: 'Автосъздаване на стойности',
        autoCreateOn: 'При задаване',
        autoCreateOff: 'Само декларираните',
        autoCreateHint: 'Включено: задаването на нова стойност я създава. Изключено: задават се само декларираните стойности',
        values: 'Стойности',
        noValues: 'Няма декларирана стойност',
        addValue: 'Добави стойност',
        duplicateValue: 'Дублирана стойност',
        kinds: 'Типове ресурси',
        kindsAll: 'Всички',
        kindsPlaceholder: 'Всички',
        kindsHint: 'Оставете празно, за да допуснете всеки тип ресурс, който поддържа тагове',
        systemChip: 'Система',
        deleteCascade: 'Премахни и присвояванията',
        deleteCascadeHint: 'Таг, който все още е присвоен на някой ресурс, се отхвърля: с тази опция стойностите и всички присвоявания изчезват заедно с тага.'
    },
    scopes: {
        title: 'Скоупове',
        createTitle: 'Създаване на скоуп',
        editTitle: 'Преименуване на скоуп',
        path: 'Път',
        segment: 'Сегмент',
        segmentHint: 'Малки букви, цифри и тирета (DNS-1123)',
        parent: 'Родител',
        rootChip: 'Корен',
        preview: 'Нов скоуп',
        pickLabel: 'Скоуп',
        pickHint: 'Къде живее обектът в дървото на клъстера — в корена или в някой vDC под него.',
        ociCache: 'OCI кеш (предефиниране)',
        appEphemeral: 'Ефемерни пулове за приложения (предефиниране)',
        inherit: 'Наследи',
        inheritsFrom: 'Наследява от',
        inheritsCluster: 'Наследява подразбирането на клъстера',
        inheritsNone: 'Наследява — няма действащ пул',
        failoverProtection: 'Защита при деградация',
        networkWeight: 'Мрежово тегло',
        networkCeil: 'Мрежов таван (Mbps)',
        protectionProtected: 'Защитен',
        protectionExpendable: 'За пожертване при деградация',
        protectionDefault: 'По подразбиране за клъстера'
    },

    // Система > Информация (рунд #124, 2026-07-31): версии на платформата във
    // флота (най-много две по време на обновление), компоненти по възли, PDF
    // ръководство, обслужвано локално, и вградената карта на лиценза.
    sysinfo: {
        summary: 'Версии на платформата в клъстера, компонентите на всеки възел, ръководството за администриране и лицензът.',
        platformTitle: 'Платформа TVirt',
        platformSubtitle: 'Версии, наблюдавани на възлите на клъстера',
        versionOnNodes: '{version} на {n} възела',
        versionOnOneNode: '{version} на 1 възел',
        mixedVersions: 'Повече от една версия на платформата в клъстера — очаквано само по време на обновление в ход (най-много две).',
        tooManyVersions: 'Повече от две версии на платформата в клъстера — това не се очаква никога, дори по време на обновление: проверете възлите по-долу.',
        unreportedNodes: 'Още няма доклад за версии от: {nodes}',
        noVersionsYet: 'Никой възел още не е докладвал версиите си.',
        nodesUnavailable: 'Списъкът с възли не е видим с вашите права — версиите на платформата не могат да бъдат показани.',
        colNode: 'Възел',
        manualTitle: 'Ръководство за администриране',
        manualSubtitle: 'Локално копие, обслужвано от този клъстер',
        manualBody: 'Пълното ръководство на TVirt в PDF, обслужвано директно от платформата — достъпно и в изолирани (air-gapped) среди.',
        manualLink: 'Ръководство за администриране (PDF)',
    apiExplorerTitle: 'Изследовател на API',
    apiExplorerSubtitle: 'Контрактът OpenAPI, разглеждаем',
    apiExplorerBody: 'Пълният OpenAPI контракт на платформата — всеки маршрут, схема и код на отговор — разглеждаем от браузъра, сервиран през този възел.',
    apiExplorerLink: 'Изследвай API',
    kubeTitle: 'Съвместимост с Kubernetes',
    kubeSubtitle: 'kubectl и инструментите му пред нативния API',
    kubeBody: 'TVirt KubeCompat проектира Pod-ове, Deployment-и, Service-и, namespace-ове, възли и събития в диалекта на Kubernetes — само за четене, плюс изтриване на Deployment-и. Всяко извикване минава през нативния API с твоите права: в kubeconfig използвай app token като bearer.',
    kubeEndpoint: 'Endpoint за kubectl',
    kubeStatusActive: 'Активен — Kubernetes {version}',
    kubeStatusMissing: 'Не е инсталиран на този възел (пакет trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Инсталиран, но не отговаря — провери unit-а trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Проверка…'
    },

    // Лицензиране (рунд 2026-07-29): страницата на абонаментния лиценз.
    licensing: {
        title: 'Лиценз на клъстера',
        subtitle: 'Абонаментен лиценз — най-много един на клъстер',
        absentTitle: 'Няма регистриран лиценз',
        absentBody:
            'Без валиден лиценз клъстерът отказва да стартира нови виртуални машини (включените ВМ остават включени). Регистрирайте продуктовия ключ, получен с абонамента.',
        registerButton: 'Регистрирай лиценз',
        removeButton: 'Премахни лиценза',
        state: {
            ok: 'Валиден',
            limitExceeded: 'Надвишен лимит',
            expired: 'Изтекъл'
        },
        productKeyLabel: 'Продуктов ключ',
        basisLabel: 'База на лимита',
        basis: {
            concurrentVms: 'Едновременно включени ВМ',
            physicalCores: 'Физически ядра (общо за клъстера)'
        },
        limitLabel: 'Лимит',
        usageLabel: 'Текуща употреба',
        usageOf: '{used} от {limit}',
        usagePartial: 'частична сума — {n} възел(а) без наблюдавана CPU топология',
        usageUnknown: 'в момента не може да се наблюдава',
        expiresLabel: 'Изтичане',
        neverExpires: 'никога',
        registeredLabel: 'Регистриран',
        gateNote:
            'При липсващ, изтекъл или надвишил лимита си лиценз клъстерът отказва да стартира НОВИ виртуални машини. Включените ВМ остават включени и HA рестартите не се засягат.',
        devStage:
            'Фаза на разработка: продуктовият ключ се приема както е, заедно с декларираните тук лимити; валидацията с подписан ключ ще дойде в бъдеща версия.',
        dialogTitle: 'Регистриране на лиценз',
        dialogExpiresHelp: 'Празно = лицензът никога не изтича',
        dialogSubmit: 'Регистрирай',
        dialogError: 'Неуспешно регистриране на лиценза.',
        removeTitle: 'Премахване на лиценза',
        removeBody:
            'Клъстерът ще остане БЕЗ ЛИЦЕНЗ: новите виртуални машини ще отказват да стартират, докато не регистрирате лиценз. Включените ВМ остават включени.',
        removeConfirm: 'Премахни',
        removeError: 'Неуспешно премахване на лиценза.'
    },
    rbac: {
        tabRoles: 'Роли',
        tabGrants: 'Делегирания',
        rolesTitle: 'Роли',
        createRoleTitle: 'Създаване на роля',
        editRoleTitle: 'Редактиране на роля',
        nameHint: 'Малки букви, цифри и тирета; префиксът tvirt- е запазен',
        systemChip: 'Система',
        permissions: 'Права',
        permissionsPlaceholder: 'Добави право…',
        includedRoles: 'Включени роли',
        includedRolesPlaceholder: 'Добави роля…',
        grantsTitle: 'Делегирания',
        createGrantTitle: 'Създаване на делегиране',
        principal: 'Принципал',
        principalKind: 'Тип принципал',
        principalUser: 'Потребител',
        principalGroup: 'Група',
        role: 'Роля',
        grantRight: 'Делегиране',
        grantRightChip: 'Може да делегира',
        grantRightLabel: 'С право на делегиране (получателят може на свой ред да делегира тази роля)',
        effective: 'Действащо',
        notEffective: 'Недействащо',
        createdAt: 'Създадено',
        scopeHint: '/path — точно, /path/* — рекурсивно; делегиранията се закотвят към монтиран корен (/* не може да се делегира)'
    },
    groups: {
        title: 'Групи',
        createTitle: 'Създаване на група',
        nameHint: 'Малки букви, цифри и тирета; уникално в рамките на скоупа',
        members: 'Членове',
        membersTitle: 'Членове',
        membersPlaceholder: 'Добави потребител…',
        noMembers: 'Няма членове',
        realmMappings: 'Съпоставяния с реалми',
        realmMappingsTitle: 'Съпоставяния с реалми',
        realmMappingsHint:
            'На какво съответства тази група във всеки външен реалм. Членството се чете от директорията в момента на входа: група от директорията, която никой не е съпоставил тук, се игнорира, а влагането не се разгръща — изравнете го откъм директорията.',
        realm: 'Реалм',
        externalGroup: 'Външна група',
        addRealmMapping: 'Добави съпоставяне',
        removeRealmMapping: 'Премахни съпоставянето',
        noRealmMappings: 'Няма съпоставяния с реалми',

        // Диалог за създаване по секции (рунд realm-wizard, 2026-08-03): «Общи»
        // плюс повърхността за съпоставяне с външните реалми, с говорещото
        // празно състояние.
        sectionGeneral: 'Общи',
        mappingsNoRealms: 'Още няма конфигуриран външен реалм — повърхността за съпоставяне се отключва веднага щом съществува реалм.',
        mappingsNoRealmsLink: 'Отвори раздела „Реалми и SSO“',

        // Изискването за MFA, налагано от групата (рунд #178, половина B): чисто
        // OR — групата може само да ДОБАВИ изискването, никога да го премахне.
        mfaRequired: 'Изискване за MFA',
        mfaRequiredChip: 'Налага MFA',
        mfaNotRequiredChip: 'Без изискване',
        mfaRequiredHint:
            'Чисто OR: групата може да ДОБАВИ изискването за втори фактор към членовете си — включително към външните идентичности, чрез съпоставянията си с реалми — но никога да го премахне. Важи от следващия вход: отворените сесии не се затварят.'
    },
    users: {
        title: 'Потребители',
        createTitle: 'Създаване на потребител',
        editTitle: 'Редактиране на потребител',
        username: 'Потребителско име',
        usernameHint: 'Малки букви, цифри, точки и тирета',
        displayName: 'Показвано име',
        enabled: 'Активиран',
        state: 'Състояние',
        enabledChip: 'Активиран',
        disabledChip: 'Деактивиран',
        lockedChip: 'Заключен',
        password: 'Парола',
        passwordSetChip: 'Зададена',
        mustChangeChip: 'За смяна',
        initialPassword: 'Начална парола',
        initialPasswordHint: 'Потребителят ще трябва да я смени при първия вход',
        lastLogin: 'Последен вход',
        neverLoggedIn: 'Никога не е влизал',
        setPasswordTitle: 'Задаване на парола',
        setPasswordHint: 'Административна замяна — изисква вашата парола (режим sudo) и задължава потребителя да я смени при следващия вход.',
        operatorPassword: 'Вашата парола',
        unlock: 'Отключи акаунта',
        revokeTitle: 'Отзоваване на сесии',
        revokeBody: 'Всички активни сесии на този потребител се прекратяват незабавно.',
        revokeIncludeTokens: 'Отзови също токените на приложенията',
        revokeConfirm: 'Отзови',

        // Стандартен диалог (рунд #156): пълни детайли, раздели акаунт/сигурност.
        tabAccount: 'Акаунт',
        tabSecurity: 'Сигурност',
        usernameImmutableHint: 'Потребителското име е идентичността на акаунта — фиксира се при създаването',
        groups: 'Групи',
        noGroups: 'Няма групи',
        mustChangePassword: 'Задължителна смяна на паролата',
        failedAttempts: 'Неуспешни опити за вход',
        lockedUntil: 'Заключен до',

        // Раздели на идентичностите (2026-08-03): «Система > Потребители» стана
        // секция с раздели по модела на /system/rbac — потребители, групи,
        // външни реалми.
        tabUsers: 'Потребители',
        tabGroups: 'Групи',
        tabRealms: 'Реалми и SSO',
        tabMfa: 'MFA',

        // Раздел MFA (задача #178): изгледът на втория фактор. Половина A —
        // таблицата по потребители върху users.yaml; половина B (контрактен
        // рунд, ратифициран 2026-08-04) — действащата присъда с произхода ѝ,
        // външните настройки със състоянието на сирак и групите, които налагат
        // изискването.
        mfa: {
            title: 'Втори фактор (MFA)',
            methodsTitle: 'Налични методи',
            methodsSubtitle: 'Това, което тази инсталация умее да проверява като втори фактор',
            methodsError: 'Неуспешно зареждане на регистъра с методи',
            builtinChip: 'Вграден',
            enrollableChip: 'Настройка в TVirt',
            delegatedChip: 'Управляван външно',
            state: 'Състояние',
            stateActive: 'Активен',
            statePending: 'Очаква настройка',
            stateNone: 'Не е настроен',
            required: 'Изискване за MFA',
            requiredChip: 'Задължителен',
            notRequiredChip: 'Не е задължителен',
            enrolledAt: 'Настроен на',
            enrolledMethods: 'Настроени методи',
            noMethods: 'Няма настройка',
            codesRemaining: 'Оставащи кодове за възстановяване',
            resetTitle: 'Нулиране на втория фактор',
            resetHint:
                'Настройката и всички кодове за възстановяване се занулят: при следващия вход потребителят ще направи настройката отначало. Изискването за MFA остава каквото е — администраторът никога не задава секрет, той само го нулира.',
            resetConfirm: 'Нулирай',
            resetError: 'Неуспешно нулиране на втория фактор',
            empty: 'Още няма управлявани потребители — акаунтите се появяват тук веднага щом съществуват, всеки със своето състояние на втория фактор.',

            // Половина B (рунд #178): произход на действащата присъда, външни
            // настройки със състоянието на сирак, групи, които налагат изискването.
            viaSelf: 'Личен',
            viaSelfHint: 'Личният принос на акаунта (неговият флаг) — единствената част, която моливът редактира.',
            viaGroupHint: 'Изискване, наследено от тази група: премахването на личния флаг не освобождава потребителя — действайте върху групата, в раздела „Групи“.',
            subject: 'Идентичност',
            lastSeenAt: 'Последно потвърждение',
            enrollmentPending: 'Изчаква',
            orphanChip: 'Осиротяла',
            orphanDirectoryMiss: 'Идентичността вече не е в директорията',
            orphanRealmRemoved: 'Реалмът е премахнат от TVirt',
            orphanedAt: 'Осиротяла от',
            directoryUuid: 'UUID в директорията',
            externalTitle: 'Външни MFA настройки',
            externalEmpty: 'Още няма външна настройка — тя се ражда при първия вход на идентичност от директорията, попадаща под изискването за MFA.',
            orphanHelp:
                'Осиротяла настройка никога не се изтрива сама: тя е материал по сигурността — остава за одита и ако идентичността се появи отново в директорията, намира фактора си отново. Единственият изход е административното нулиране.',
            visibilityHint: 'Външните настройки живеят в корена на клъстера: вижда ги само този, който има user.read върху цялото дърво.',
            orphanResetHint:
                'Осиротелият ред се премахва окончателно: никой вече не претендира за него. Ако идентичността някога се върне в директорията, ще направи настройката отначало.',
            enforcingTitle: 'Групи, които налагат MFA',
            enforcingSubtitle:
                'Котвата на изискването за външните идентичности е групата: нейните съпоставяния с реалми казват коя популация от директорията достига то. Външната настройка се ражда при първия вход на задължения потребител.',
            enforcingEmpty: 'Никоя група не налага MFA — изискването се включва върху групата, от раздела „Групи“.',
            enforcingError: 'Неуспешно зареждане на групите, които налагат MFA'
        }
    },
    realms: {
        title: 'Реалми за автентикация',
        createTitle: 'Създаване на реалм',
        editTitle: 'Редактиране на реалм',
        name: 'Реалм',
        nameHint: 'Домейнът, който потребителите пишат след @ (example.com) — неизменяем след създаването',
        nameImmutableHint: 'Името на реалма е отпечатано във всяка сесия и във всеки ред на одита, който някога го е споменал — преименуването би пренаписало историята',
        kind: 'Тип',
        kindLdap: 'LDAP / Active Directory',
        kindHint: 'OIDC и SAML идват със следващите рундове — днес реалмът е LDAPv3 директория',

        // Полусъветник за създаване (рунд realm-wizard, 2026-08-03): картите на
        // типовете от стъпка 1 — ldap жив, oidc/saml като карти в пътната карта
        // (никога формуляр без бекенд зад него).
        kindCategory: 'Тип реалм',
        kindSelectHint: 'Изберете типа директория, срещу която този реалм ще автентикира.',
        kindCard: {
            ldap: {
                name: 'LDAP / Active Directory',
                desc: 'Потребителско име и парола, проверявани с bind към LDAPv3 директория — Active Directory, FreeIPA, OpenLDAP.'
            },
            oidc: {
                name: 'OpenID Connect',
                desc: 'Единен вход от браузъра, делегиран на доставчик на идентичност OpenID Connect — идва със следващите рундове.'
            },
            saml: {
                name: 'SAML 2.0',
                desc: 'Корпоративен единен вход с твърдения SAML 2.0 — идва със следващите рундове.'
            }
        },
        tabBind: 'Bind',
        enabled: 'Активиран',
        urls: 'Сървъри на директорията',
        urlsHint: 'По един URL ldap:// или ldaps:// на ред (1–8), опитвани поред — аварийно превключване, никога балансиране',
        startTls: 'StartTLS',
        verifyCertificate: 'Проверка на сертификата',
        cleartextWarning: 'Без ldaps:// или StartTLS паролата за bind прекосява мрежата в чист текст — приемливо в лаборатория, никога в продукция.',
        noVerifyWarning: 'Непроверена TLS сесия не автентикира никого: изключвайте проверката само срещу директория, която не можете да поправите.',
        caCertificate: 'CA сертификат (PEM)',
        caCertificateHint: 'Незадължителен CA пакет, фиксиран за TLS/StartTLS ръкостискането на този реалм; празно поле го премахва',
        caCertificatePinned: 'Фиксиран',
        connectTimeout: 'Таймаут (секунди)',
        connectTimeoutHint: 'Краен срок за връзка и заявка за всеки URL (1–60); при изтичането му се опитва следващият URL',
        bindDn: 'Bind DN',
        bindDnHint: 'Сервизният акаунт, който изпълнява търсенето на потребителя; празно = анонимен search bind (отказван от AD)',
        anonymousBind: 'Анонимен search bind',
        bindCredential: 'Парола за bind (хранилище за ключове)',
        bindCredentialHint: 'Запис usernamePassword в хранилището за ключове с паролата за bind — секретът никога не живее върху реалма',
        bindCredentialNone: 'Няма (анонимен bind)',
        bindCredentialEmpty: 'Няма запис usernamePassword в хранилището за ключове — създайте един в „Система > Идентификационни данни“ за паролата за bind.',
        baseDn: 'Base DN',
        baseDnHint: 'Поддървото, от което започва търсенето на потребителя (DC=example,DC=com)',
        userFilter: 'Филтър за потребител',
        userFilterHint: '%u се замества с локалната част на името за вход, с екраниране по RFC 4515; директориите извън AD обикновено искат (&(objectClass=inetOrgPerson)(uid=%u))',
        memberOfAttribute: 'Атрибут memberOf',
        memberOfAttributeHint: 'Чете се само веднъж, при входа — несъпоставените групи се игнорират, влагането не се разгръща',
        uuidAttribute: 'Атрибут UUID',
        uuidAttributeHint: 'Неизменяемият UUID в рамките на реалма (objectGUID в AD, entryUUID в OpenLDAP) — отпечатва се в одита до потребител@реалм',
        displayNameAttribute: 'Атрибут за показваното име',
        displayNameAttributeHint: 'Използва се за поздрав към потребителя; при липса се използва името за вход',
        sudoHint: 'Записите по реалмите са защитени с режим sudo: реалмът е входна врата към платформата',
        deleteBody: 'Съпоставянията на групи на реалма си отиват с него; сесиите, които той е автентикирал, остават живи до изтичането си — изтрит реалм просто не пуска никого повече.',
        tabConnection: 'Връзка',
        tabDirectory: 'Директория',
        testTitle: 'Проба на връзката',
        testHint: 'Сонда за конфигурацията, никога автентикация: свързва се, прави bind със сервизния акаунт и — при подадено потребителско име — изпълнява филтъра за потребител.',
        testUsername: 'Потребителско име (незадължително)',
        testUsernameHint: 'Локална част, върху която да се изпълни филтърът за потребител — 1 съвпадение е здравият отговор',
        testRun: 'Изпълни пробата',
        testError: 'Неуспешно изпълнение на сондата',
        testReachable: 'Директорията е достъпна, сервизният bind е приет',
        testUnreachable: 'Директорията НЕ е достъпна',
        matchedOne: 'Филтърът за потребител намери точно 1 запис — здравият отговор.',
        matchedNone: 'Филтърът за потребител не намери нито един запис: филтърът или base DN е сгрешен.',
        matchedMany: 'Филтърът за потребител намери {count} записа: не е избирателен и входовете биха били двусмислени (отказват се).',
        mappingsPointer: 'На какво съответства една външна група е свойство на групата в TVirt (нейните съпоставяния с реалми): точката на истината живее в раздела „Групи“.',
        mappingsPointerLink: 'Отвори раздела „Групи“',
        rootHomeHint: 'Идентичностите на един външен реалм живеят в корена на клъстера, никога във vDC: правата се дават там, където трябват, с делегирания — върху групата или директно върху потребителя, точно както за местните.'
    },
    credentials: {
        title: 'Идентификационни данни',
        createTitle: 'Създаване на идентификационни данни',
        editTitle: 'Редактиране на идентификационни данни',
        kind: 'Тип',
        kindUsernamePassword: 'Потребителско име и парола',
        kindIscsiChap: 'CHAP (iSCSI)',
        kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
        kindCephx: 'cephx (Ceph идентичност)',
        kindHintUsernamePassword: 'Неизменяеми. За CIFS/SMB хранилища — акаунтът за монтиране, чийто секрет уъркърът използва в момента на монтирането.',
        kindHintIscsiChap: 'Неизменяеми. За CHAP автентикацията в iSCSI — username = CHAP име, secret = CHAP секрет.',
        kindHintNvmeDhchap: 'Неизменяеми. За DH-HMAC-CHAP на NVMe over Fabrics — secret = блобът DHHC-1:xx:…; username е само етикет.',
        kindHintCephx: 'Неизменяеми. За Ceph клиенти — username = име на клиента (client.…), secret = ключът в base64.',
        kindImmutableHint: 'Типът е неизменяем след създаването — смяната му означава нови идентификационни данни.',
        username: 'Потребителско име',
        usernameChap: 'CHAP име',
        usernameNvme: 'Етикет',
        usernameCephx: 'Име на клиента',
        usernameHint: 'Незадължителен акаунт, на който принадлежи секретът',
        usernameHintChap: 'CHAP името, с което инициаторът се автентикира',
        usernameHintNvme: 'Не се използва от транспорта — свободен етикет за вашите бележки',
        usernameHintCephx: 'Името на cephx клиента — префиксът client. се толерира',
        secret: 'Секрет',
        secretHint: 'Само за запис: използва се от консуматорите, никога повече не се показва.',
        secretHintNvmeDhchap: 'Само за запис: DH-HMAC-CHAP секретът на хоста в каноничната форма DHHC-1:xx:… — използва се от консуматорите, никога повече не се показва.',
        secretHintCephx: 'Само за запис: cephx ключът в base64 — използва се от консуматорите, никога повече не се показва.',
        secretEditHint: 'Оставете празно, за да не сменяте секрета — попълването го ротира.',
        createdAt: 'Създадени',
        inUseError: '„{name}“ се използва от конфигурацията на едно от хранилищата — първо го откачете там.',
        nameHint: 'Малки букви, цифри и тирета (DNS-1123); уникално в рамките на скоупа',

        // Диалог само за ротация (рунд #156): секретът никога няма молив в реда.
        rotateTitle: 'Ротация на секрета',
        rotateHint: 'Само за запис: новият секрет заменя съхранения — консуматорите ще го вземат при следващото монтиране.',

        // Рунд #159 (PKI): разделите «Сертификати» и «CA».
        tabSecrets: 'Секрети',
        tabCertificates: 'Сертификати',
        tabAuthorities: 'Сертифициращи органи',
        certificatesTitle: 'Сертификати',
        authoritiesTitle: 'Сертифициращи органи',
        caCreateTitle: 'Нов CA',
        certCreateTitle: 'Нов сертификат',
        caMode: 'Източник',
        caModeGenerate: 'Генериране с TVirt',
        caModeImport: 'Импорт (ключ + сертификат)',
        certMode: 'Източник',
        certModeIssue: 'Издаване от CA в хранилището за ключове',
        certModeImport: 'Импорт (ключ + сертификат)',
        issuingCa: 'Издаващ CA',
        issuingCaHint: 'Сертификатът се ражда в скоупа на своя CA, с регистриран родител',
        noCasHint: 'Няма CA в хранилището за ключове — първо генерирайте или импортирайте един в раздела „CA“',
        commonName: 'Common name (CN)',
        commonNameCaHint: 'Субектът на CA: букви, цифри, интервал, точка, долна черта, тире',
        commonNameCertHint: 'OpenVPN разпознава клиентите по CN — дръжте го уникален в рамките на CA',
        days: 'Валидност (дни)',
        daysCaHint: '1–7300 дни; 3650 (10 години) е по подразбиране',
        daysCertHint: '1–3650 дни; 365 е по подразбиране',
        keyType: 'Тип ключ',
        keyTypeHint: 'EC P-256 е по подразбиране; RSA — за наследени консуматори',
        usage: 'Предназначение',
        usageClient: 'Клиент (clientAuth)',
        usageServer: 'Сървър (serverAuth)',
        usageHint: 'Разширеното предназначение на ключа (extended key usage), за което сертификатът се издава',
        san: 'Алтернативни имена (SAN)',
        sanHint: 'Разделени със запетая; IP литералите стават записи IP:, останалото — DNS:',
        keyPem: 'Частен ключ (PEM)',
        keyPemHint: 'Само за запис: пази се в хранилището за ключове, никога повече не се показва',
        certPem: 'Сертификат (PEM)',
        certPemHint: 'Публичният сертификат, който се сдвоява с ключа',
        certPemCaHint: 'CA сертификатът, който се сдвоява с ключа (basicConstraints CA)',
        subject: 'Субект',
        issuer: 'Издател',
        parentCa: 'Издаващ CA',
        parentCaImported: 'Импортиран — издаден извън TVirt',
        serial: 'Сериен номер',
        fingerprint: 'Отпечатък (SHA-256)',
        validFrom: 'Валиден от',
        validUntil: 'Валиден до',
        expiry: 'Изтичане',
        expired: 'Изтекъл',
        expiresInDays: 'Изтича след {days} д',
        revoked: 'Отзован',
        revokedAtLabel: 'Отзован на',
        revokeTitle: 'Отзоваване на сертификат',
        revokeAction: 'Отзови',
        revokeWarning: 'Отзоваването е окончателно: серийният номер влиза в CRL на издаващия CA и всеки консуматор, който отхвърля отзовани сертификати (OpenVPN на първо място), ще отхвърли и този. Обратно действие не съществува.',
        exportPem: 'Експортирай PEM',
        exportChain: 'Експортирай пакета с веригата',
        exportCrl: 'Експортирай CRL',
        materialImmutableHint: 'X.509 материалът е неизменяем — преиздайте или импортирайте наново',
        caInUseError: '„{name}“ още има живи издадени сертификати (или хранилище го реферира) — първо ги отзовете или изтрийте.'
    },
    proximity: {
        title: 'TVirt Proximity',
        subtitle: 'Разполагане, достъпност и афинитет — къде работят ВМ на клъстера и дали трябва да са включени',
        loadError: 'Панелът Proximity изисква хранилището на конфигурацията на клъстера — състоянието на флота в момента е недостъпно',
        config: {
            title: 'Конфигурация',
            subtitle: 'Политика за разполагане на ниво клъстер',
            save: 'Запази',
            saveError: 'Конфигурацията беше отказана',
            strategy: 'Стратегия на подбор',
            strategy_leastUsedResources: 'Най-малко използвани ресурси',
            strategy_leastVms: 'Най-малко ВМ',
            strategy_random: 'Случайно',
            strategyLeastUsedResourcesHint: 'Измежду годните кандидати — възелът с най-много оставаща използваема RAM (наблюдавано общо − резерв на хоста − включени ВМ); при равенство решава ангажиментът по vCPU. Детерминирана при еднакви данни.',
            strategyLeastVmsHint: 'Измежду годните кандидати — възелът с най-малко включени ВМ; равенствата се решават по име. Детерминирана при еднакви данни.',
            strategyRandomHint: 'Равномерно случайно измежду годните кандидати.',
            liveness: 'Праг на жизненост на възлите (секунди)',
            livenessHint: 'Член, мълчащ отвъд прага, е недостъпен: изключва се от разполагането и — ако не е в поддръжка — се смята за мъртъв от HA решателя, който го изолира (фенсинг) и рестартира неговите HA ВМ другаде.',
            decider: 'HA решател',
            deciderNone: 'още не е избран'
        },
        nodesTitle: 'Възли',
        nodesSubtitle: 'Жизненост и емпиричен капацитет — използваема RAM = общо − база − ангажирана',
        nodeCol: 'Възел',
        stateCol: 'Състояние',
        ramCol: 'RAM (общо − база − ангажирана)',
        usableCol: 'Използваема',
        vmsCol: 'Натоварване',
        neverSeen: 'никога не е виждан',
        freshChip: 'достъпен',
        staleChip: 'недостъпен',
        attestedChip: 'атестиран като изключен',
        ramFormula: 'общо − база − ангажирана',
        haTitle: 'Висока достъпност',
        haSubtitle: 'ВМ с HA флаг са „винаги включени“: TVirt ги рестартира след всяко непоискано спиране — на същия възел с изчакване (backoff), на друг възел, когато техният умре (само споделено хранилище).',
        haNone: 'Никоя ВМ още няма HA флаг — включете го тук или в детайлите на ВМ.',
        haVmCol: 'Виртуална машина',
        haStateCol: 'Състояние',
        haRestartsCol: 'HA рестарти',
        haLastEventCol: 'Последно събитие',
        haToggleCol: 'HA',
        haCrashLoop: 'цикъл от сривове',
        haToggleError: 'Промяната на HA беше отказана',
        rules: {
            title: 'Правила за афинитет',
            createTitle: 'Ново правило за близост',
            editTitle: 'Редактиране на правило',
            nameHint: 'Малки букви, цифри и тирета (DNS етикет)',
            vms: 'Виртуални машини',
            vmsHint: 'Поне две ВМ — правилото обвързва къде работят едните спрямо другите',
            type: 'Тип',
            affinity: 'Афинитет (заедно)',
            antiAffinity: 'Анти-афинитет (разделени)',
            typeAffinityHint: 'ВМ трябва да работят на ЕДИН И СЪЩ възел.',
            typeAntiAffinityHint: 'ВМ трябва да работят на РАЗЛИЧНИ възли — класическата HA двойка.',
            mode: 'Режим',
            hard: 'hard',
            soft: 'soft',
            modeHardHint: 'Нарушенията отказват операцията (стартиране, миграция, аварийно превключване) с говореща грешка.',
            modeSoftHint: 'Предпочитание, никога блокиращо: разполагане в нарушение продължава с видимо предупреждение.',
            satisfied: 'Разполагане',
            satisfiedYes: 'спазено',
            satisfiedNo: 'нарушено',

            // Стандартен диалог (рунд #156): нарушенията имат свой ред, не подсказка.
            violations: 'Нарушения',
            noViolations: 'Няма'
        },
        events: {
            title: 'HA събития',
            subtitle: 'Логът на достъпността — рестарти, фенсинг, аварийни превключвания и честните пропуски',
            none: 'Още нищо.',
            when: 'Кога',
            kind: 'Събитие',
            target: 'Обект',
            detail: 'Детайл',
            kindRestarted: 'HA рестарт',
            kindGaveUp: 'отказване (цикъл от сривове)',
            kindNodeAttested: 'възел фенсиран',
            kindFailedOver: 'аварийно превключване',
            kindNoCandidate: 'няма кандидат',
            kindStorageLocalSkip: 'пропуснато (локално хранилище)',
            kindZombieFenced: 'зомби прекратено'
        }
    }
}
